import React, { useContext, useEffect, useState } from "react";
import TypographyComponent from "../../components/Typography/ThypographyComponent";
import DashboardTitleComponent from "../../components/layout/Dashboard/Title/DashboardTitleComponent";
import BoxComponent from "../../components/Box/BoxComponent";
import ButtonComponent from "../../components/Button/ButtonComponent";
import ButtonFilterPedidoComponent from "./components/ButtonFilterPedidoComponent";
import TextFieldComponent from "../../components/TextField/TextFieldComponent";
import SearchIcon from "../../assets/icons/search_icon.png"
import ImageComponent from "../../components/Image/ImageComponent";

import ListaPedidosComponent from "./components/ListaPedidosComponent";
import { useParams } from "react-router-dom";
import { Client } from "@stomp/stompjs";
import SockJS from 'sockjs-client';
import { EmpresaContext } from "../../provider/empresa/EmpresaContext";
import { pedidoService } from "../../service/PedidoService";
import { AuthContext } from "../../provider/auth/AuthContext";
import { removeCaracteresEspeciais, spaceToUnderscore } from "../../utils/texto";
import { Usuario, UsuarioEnderecos } from "../../provider/auth/AuthProps";
import { ResponseErrorDTO } from "../../api/ResponseProps";
import ModalNovoPedidoComponent from "./components/modal/novo_pedido/ModalNovoPedidoComponent";
import { CatalogoComplemento, CatalogoComplementoEspecifico, CatalogoOpcao, CategoriasProps, DetalheItem, ItemCarrinho, ItemDestaque, ModalDetalheCatalogo } from "../Cardapio/public/CatalogoPage";
import { catalogoService } from "../../service/CatalogoService";

// ICONS
import { ReactComponent as PratoTalheresIcon } from "../../assets/icons/prato_talheres.svg";
import { ReactComponent as PizzasIcon } from "../../assets/icons/pizzas.svg";
import { ReactComponent as HamburguerIcon } from "../../assets/icons/hamburguer.svg";
import { ReactComponent as CombosIcon } from "../../assets/icons/combos.svg";
import { ReactComponent as BebidasIcon } from "../../assets/icons/bebidas.svg";
import { ReactComponent as EntradasIcon } from "../../assets/icons/entradas.svg";
import { empresaService } from "../../service/EmpresaService";
import { usuarioService } from "../../service/UsuarioService";
import { apenasNumero } from "../../utils/numero";
import axios from "axios";
import ModalDetalhesItemComponent from "../Cardapio/public/components/item/ModalDetalhesItemComponent";

export interface ItensProps {
    titulo: string;
    qtd: number;
    vlrUnitario: number;

    opcao?: CatalogoOpcao;
    complementos?: CatalogoComplemento[];
    complementosEspecificos?: CatalogoComplementoEspecifico[];
}

interface PedidosPorStatusDTO {
    idEtapa: number;
    status: string;
    quantidade: number;
    pedidos: InfoPedidoProps[];
}

export interface InfoPedidoProps {
    id: number;
    idEtapa: number;
    infoSolicitante: Usuario;
    itens: ItensProps[];
    status: string;
    tipo: string;
    valor: number;
    vlrTroco: number;
    canal: string;
    dataInicial: Date;
    dataPrevista: Date;
    //itens: string[]

    isPermitidoCancelar: boolean;
    isPermitidoConfirmar: boolean;
    isConcluido: boolean;
    isCancelado: boolean;
    observacao?: string;
    endereco?: UsuarioEnderecos
}

interface ModalNovoPedidoProps {
    open: boolean;
}

const PedidosPage = (props: any) => {
    const [searchPedidoInput, setSearchPedidoInput] = useState<string>("");
    const [detalhePedido, setDetalhePedido] = useState<InfoPedidoProps>();

    //const { empresa } = useParams();
    const { usuario, token } = useContext(AuthContext);
    const { empresa } = useContext(EmpresaContext);

    const handleChangeSearchPedido = (value: string) => {
        setSearchPedidoInput(value);
    }

    const handleClickPedido = (id: number, element: InfoPedidoProps) => {
        setDetalhePedido(element);
        alert("cliquei no pedido #" + id);
    }

    const handleClickConfirmacaoPedido = async (id: number) => {
        const token = localStorage.getItem("token");

        if (token != null) {
            try {
                const response = await pedidoService.avancarEtapaPedido(id, token);
                setDetalhePedido(undefined);
            } catch (e: any) {
                if (e.message) alert(e.message);
                else alert("Falha durante avanço de etapa do pedido.");
            }
        }
    }

    const handleCancelaPedido = async (id: number) => {
        const token = localStorage.getItem("token");

        if (token != null) {
            try {
                const response = await pedidoService.cancelarPedido(id, token);
                setDetalhePedido(undefined);
            } catch (e: any) {
                if (e.message) alert(e.message);
                else alert("Falha durante avanço de etapa do pedido.");
            }
        }
    }

    // CONEXÃO COM O SOCKET
    useEffect(() => {
        const token = localStorage.getItem("token");
        const socket = new SockJS(`${process.env.REACT_APP_API}/ws`);

        // Busca por pedidos
        if (empresa?.id != null && token != null) {
            getPedidos(empresa?.id, token);
        }

        const stompClient = new Client({
            webSocketFactory: () => socket,
            reconnectDelay: 5000,
            // connectHeaders: {
            //     Authorization: `Bearer ${token}`,
            // },
            debug: (str) => {
            },
            onConnect: () => {
                stompClient.subscribe(`/topic/empresa/${empresa?.id}/pedidos/novo`, (response) => {
                    if (empresa && token) getPedidos(empresa?.id, token);
                });

                // stompClient.subscribe(`/topic//${empresa?.id}`, (response) => {
                //     console.log('Received message:', response.body);
                // });

                stompClient.subscribe(`/topic/empresa/${empresa?.id}/pedidos/status`, (response) => {
                    if (empresa && token) getPedidos(empresa?.id, token);
                });
            },
            onStompError: (frame) => {
                console.error('Broker reported error: ' + frame.headers['message']);
                console.error('Additional details: ' + frame.body);
            },
        });

        stompClient.activate();

        return () => {
            stompClient.deactivate();
        };
    }, [empresa?.id]);

    const [pedidosAgrupados, setPedidosAgrupados] = useState<PedidosPorStatusDTO[]>();
    const getPedidos = async (idEmpresa: number, token: string) => {
        if (token != null) {
            try {
                const pedidos = await pedidoService.getPedidos(idEmpresa, token);
                setPedidosAgrupados(pedidos);
            } catch (e: any) {
                if (e.message) alert(e.message);
                else alert("Falha durante busca de pedidos.");
            }
        }
    }

    // GERENCIAMENTO DE MODAL
    // MODAL DE CRIAÇÃO NOVO PEDIDO
    const [modalNovoPedido, setModalNovoPedido] = useState<ModalNovoPedidoProps>({
        open: false
    });

    // LISTAGEM DAS CATEGORIAS
    const [categoriaSelecionada, setCategoriaSelecionada] = useState<string>("MAIS_PEDIDOS");
    const [categorias, setCategorias] = useState<CategoriasProps[]>([]);
    const handleCategoriaSelecionada = (categoria: string) => {
        setCategoriaSelecionada(categoria);
    }

    const getCategorias = async (id: number) => {
        try {
            const categoriasApi = await catalogoService.getCategorias(id);

            const categoriasFormatadas: CategoriasProps[] = [
                { label: "Mais pedidos", value: "MAIS_PEDIDOS", icon: <PratoTalheresIcon /> }
            ];

            if (Array.isArray(categoriasApi)) {
                categoriasApi.forEach((item: CategoriasProps) => {
                    let icon;

                    if (item.label.includes("Pizza")) icon = <PizzasIcon />;
                    else if (item.label.includes("Hambúrguer")) icon = <HamburguerIcon />;
                    else if (item.label.includes("Combos")) icon = <CombosIcon />;
                    else if (item.label.includes("Bebidas")) icon = <BebidasIcon />;
                    else if (item.label.includes("Entradas")) icon = <EntradasIcon />;

                    categoriasFormatadas.push({
                        label: item.label,
                        value: item.value,
                        icon
                    });
                });
            }

            setCategorias(categoriasFormatadas);

        } catch (e) {
            console.error(e);
        }
    }

    // LISTAGEM DOS ITENS (POR CATEGORIA)
    const [itens, setItens] = useState<ItemDestaque[]>([]);
    const getCatalogo = async (id: number) => {
        try {
            const data = await catalogoService.getCatalogo(id, categoriaSelecionada);
            setItens(data);
        } catch (e) {
            console.error(e);
        }
    }

    // NOME DO CLIENTE (AUTOCOMPLETE)
    const [telefoneCliente, setTelefoneCliente] = useState<string>("")
    const [nomeCliente, setNomeCliente] = useState<string>("");
    const [dadosUsuariosCadastrados, setDadosUsuariosCadastrados] = useState<Usuario[]>([]);
    const [dadosUsuarioSelecionado, setDadosUsuarioSelecionado] = useState<Usuario>();
    const handleChangeTelefone = async (telefone: string) => {
        if (token == null) return;
        setTelefoneCliente(telefone);

        const apenasNumeros = apenasNumero(telefone);

        if (apenasNumeros.length === 11) {
            try {
                const data = await usuarioService.getUsuarioAutocomplete(telefone, token);
                if (data !== null) setDadosUsuariosCadastrados([data]);
            } catch (e) {
                console.error(e);
                //setTelefoneCliente("");
            }
        }
    }
    const handleChangeUsuarioSelecionado = (usuario: Usuario) => {
        setDadosUsuarioSelecionado(usuario);
    }
    const handleChangeDadosUsuarioSelecionado = (usuario: Usuario) => {
        setDadosUsuarioSelecionado(usuario);
    }

    const handleChangeNomeCliente = (nome: string) => {
        setNomeCliente(nome);
    }

    // ENDERECO SELECIONADO
    const [enderecoSelecionado, setEnderecoSelecionado] = useState<UsuarioEnderecos>();
    const handleChangeEnderecoSelecionado = (endereco: UsuarioEnderecos) => {
        setEnderecoSelecionado(endereco);
    }

    // TIPO (DELIVERY, MESA, BALCAO)
    const [tipoPedido, setTipoPedido] = useState('');
    const handleChangeTipoPedido = (value: string) => {
        setTipoPedido(value);
    }

    // PEDIDO PARA... (AGORA, POR ENQUANTO)

    // OBSERVACOES
    const [observacao, setObservacao] = useState<string>("");
    const handleChangeObservacao = (value: string) => {
        setObservacao(value);
    }

    // FORMA DE PAGAMENTO
    const [formasPagamento, setFormasPagamento] = useState<any[]>([]);
    const [formaSelecionada, setFormaSelecionada] = useState<string>("");
    const getFormasPagamento = async (id: number) => {
        try {
            const data = await empresaService.getFormasPgtoPublico(id);
            setFormasPagamento(data);
        } catch (e) {
            console.error(e);
        }
    }

    const handleChangeFormaPgto = (value: any) => {
        setFormaSelecionada(value);
    }

    // MODAL DETALHE ITEM
    const [modalDetalheCatalogo, setModalDetalheCatalogo] = useState<ModalDetalheCatalogo>({
        open: false,
        item: undefined
    });

    const handleClickModalDetalheCatalogo = (item: ItemDestaque) => {
        setModalDetalheCatalogo({
            open: true,
            item: item
        });
    }

    const handleCloseModalDetalheCatalogo = () => {
        setModalDetalheCatalogo({
            open: false,
            item: undefined
        });
    }

    const mountItemCarrinho = (
        novoItem: DetalheItem
    ) => {
        setItensCarrinho((prev: any) => catalogoService.mountItemCarrinho(prev, novoItem));
        handleCloseModalDetalheCatalogo();
    };

    // CARRINHO
    const [itensCarrinho, setItensCarrinho] = useState<ItemCarrinho[]>([]);
    const handleChangeCarrinho = async (novoItem: ItemDestaque) => {
        handleClickModalDetalheCatalogo(novoItem);
        //setItensCarrinho((prev: any) => catalogoService.mountItemCarrinho(prev, novoItem));
    }

    const handleUpdateQtd = (id: string, delta: number) => {
        setItensCarrinho((prev: any[]) => prev.map(i =>
            i.item.id === id ? { ...i, qtd: Math.max(1, i.qtd + delta) } : i
        ));
    }

    const handleRemoveItem = (id: string) => {
        setItensCarrinho((prev: any[]) => prev.filter(i => i.item.id !== id));
    };

    // Cálculo do total
    const totalGeral = itensCarrinho.reduce((acc, curr) => acc + (curr.vlrUnitario * curr.qtd), 0);

    const handleOpenModalNovoPedido = async () => {
        if (empresa) {
            const id = empresa.id;
            // LISTAGEM DAS CATEGORIAS
            await getCategorias(id);

            // LISTAGEM DOS ITENS (POR CATEGORIA)
            getCatalogo(id)

            // FORMA DE PAGAMENTO
            getFormasPagamento(id);

            setModalNovoPedido({
                ...modalNovoPedido,
                open: true
            });
        }
    }

    const handleCloseModalNovoPedido = () => {
        setModalNovoPedido({
            ...modalNovoPedido,
            open: false
        });

        handleCategoriaSelecionada("MAIS_PEDIDOS");
        setCategorias([]);
        setItens([]);
        handleChangeTipoPedido("");
        handleChangeObservacao("");
        setItensCarrinho([]);
        setFormasPagamento([]);
        handleChangeFormaPgto("");
    }

    const handleEnvioNovoPedido = async () => {
        if (usuario == null || token == null) {
            return;
        }

        if (itensCarrinho === null || itensCarrinho.length === 0) {
            alert("Insira ao menos um item neste pedido.");
            return;
        }

        var form = new FormData();
        form.append("idEmpresa", String(empresa?.id ?? ""));
        //form.append("idFormaPgto", formaSelecionada);
        if (formaSelecionada != null || formaSelecionada != undefined) form.append("formaPagamento", JSON.stringify(formaSelecionada));
        form.append("tipo", tipoPedido);
        form.append("observacao", observacao);
        if (dadosUsuarioSelecionado != null || dadosUsuarioSelecionado != undefined) form.append("dadosSolicitante", JSON.stringify(dadosUsuarioSelecionado));
        form.append("nomeCliente", nomeCliente);

        for (let i = 0; i < itensCarrinho.length; i++) {
            const itemCarrinho = itensCarrinho[i];

            form.append(`itens[${i}].idCatalogo`, String(itemCarrinho.item.id));
            form.append(`itens[${i}].qtd`, itemCarrinho.qtd.toString());

            // Complementos
            const complementos = itemCarrinho.item.complementos ?? [];
            if (Array.isArray(complementos) && complementos !== null) {
                complementos.forEach((complemento: any, j: number) => {
                    form.append(`itens[${i}].complementos[${j}].id`, String(complemento.id));
                    form.append(`itens[${i}].complementos[${j}].nome`, complemento.nome);
                    form.append(`itens[${i}].complementos[${j}].vlrUnitario`, String(complemento.vlrUnitario));
                    //form.append(`itens[${i}].complementos[${j}].ativo`, String(complemento.ativo));
                });
            }

            const complementosEspecificos = itemCarrinho.item.complementosEspecificos;
            if (Array.isArray(complementosEspecificos) && complementosEspecificos !== null) {
                // Complementos específicos
                complementosEspecificos.forEach((complemento: any, j: number) => {
                    form.append(`itens[${i}].complementosEspecificos[${j}].id`, String(complemento.id));
                    form.append(`itens[${i}].complementosEspecificos[${j}].nome`, complemento.nome);
                    form.append(`itens[${i}].complementosEspecificos[${j}].vlrUnitario`, String(complemento.vlrUnitario));
                });
            }

            // Opção
            form.append(`itens[${i}].opcao.id`, String(itemCarrinho.item.opcao.id));
            form.append(`itens[${i}].opcao.idEmpresa`, String(empresa?.id ?? ""));
            form.append(`itens[${i}].opcao.nome`, String(itemCarrinho.item.opcao.nome));
            form.append(`itens[${i}].opcao.tipo`, String(itemCarrinho.item.opcao.tipo));
            form.append(`itens[${i}].opcao.descricao`, String(itemCarrinho.item.opcao.descricao));
        }

        form.append("endereco", JSON.stringify(enderecoSelecionado));

        try {
            const response = await pedidoService.registerPedido(form, token);
            alert(response.data.mensagem);
            setItensCarrinho([]);
            handleCloseModalNovoPedido();
        } catch (e: unknown) {
            if (axios.isAxiosError<ResponseErrorDTO>(e)) {
                const mensagem =
                    e.response?.data?.message || "Erro ao processar pedido";

                alert(mensagem);
            } else {
                alert("Erro inesperado");
            }
        }
    }

    useEffect(() => {
        if (empresa) {
            getCatalogo(empresa.id);
        }
    }, [categoriaSelecionada])

    return <>
        <DashboardTitleComponent title="Últimos pedidos" />

        {/* SECAO DOS BOTOES E FILTROS PARA BUSCA */}
        <BoxComponent
            component="section"
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 1.4,
                    height: "36px"
                }}
            >
                <ButtonFilterPedidoComponent
                    id="plataforma"
                    label="Plataforma" value="PLATAFORMA"
                    count={0}
                    color="#364153"
                    backgroundColor="#F9FAFB"
                    borderColor="#E5E7EB"
                    onClick={(value: string) => alert(value)}
                />

                <ButtonFilterPedidoComponent
                    id="ifood"
                    label="iFood" value="IFOOD"
                    count={0}
                    color="#C10007"
                    backgroundColor="#FEF2F2"
                    borderColor="#FFC9C9"
                    onClick={(value: string) => alert(value)}
                    disabled={true}
                />

                {pedidosAgrupados?.map((element: PedidosPorStatusDTO, index: number) => {
                    const textoSemCaracteres = removeCaracteresEspeciais(element.status);
                    const cores = pedidoService.getCoresPorStatus(textoSemCaracteres.toUpperCase());

                    return <ButtonFilterPedidoComponent
                        id={spaceToUnderscore(textoSemCaracteres)}
                        key={`botao-filtro-${index}`}
                        label={element.status} value={textoSemCaracteres}
                        count={element.quantidade}
                        color={cores?.color}
                        backgroundColor={cores?.backgroundColor}
                        borderColor={cores?.borderColor}
                        onClick={(value: string) => alert(value)}
                    />
                })}
            </BoxComponent>

            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1.4,
                    height: "36px"
                }}
            >
                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "100%",
                        border: "1px solid #E8DFD5",
                        borderRadius: "6px",
                        gap: 1.3,
                        px: 1.2
                    }}
                >
                    <ImageComponent
                        alt="search_icon_input"
                        src={SearchIcon}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 25,
                            height: 25
                        }}
                    />
                    <TextFieldComponent
                        id="buscapedido"
                        variant="standard"
                        placeholder="Pesquisar por cliente ou número"
                        sx={{
                            height: 36,
                            width: "250px",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: "center",
                            boxSizing: 'border-box',
                        }}
                        fullWidth
                        disableUnderline={true}
                        value={searchPedidoInput}
                        onInput={(e) => {
                            const target = e.target as HTMLInputElement;
                            handleChangeSearchPedido(target.value);
                        }}
                    />
                </BoxComponent>

                <ButtonComponent
                    id={props.id}
                    sx={{
                        height: 36,
                        opacity: 1,
                        transform: 'rotate(0deg)',

                        // Espaçamento (Vertical: 6px, Horizontal: 12px)
                        py: '8px',
                        px: '12px',

                        // Layout Interno
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        boxSizing: 'border-box',
                        backgroundColor: "#FF8C42",
                        borderRadius: '6px',
                        color: "#FFFFFF",
                        border: `2px solid ${props.borderColor}`,
                        boxShadow: "0px 2px 8px 0px #3D281714",
                        textTransform: "inherit"
                    }}
                    onClick={handleOpenModalNovoPedido}
                >
                    <TypographyComponent
                        variant="body2" fontWeight="bold"
                        sx={{

                        }}
                    >
                        +
                    </TypographyComponent>
                    <TypographyComponent
                        variant="body2" fontWeight="bold"
                        sx={{

                        }}
                    >
                        Novo pedido
                    </TypographyComponent>
                </ButtonComponent>
            </BoxComponent>
        </BoxComponent>

        <ModalNovoPedidoComponent
            open={modalNovoPedido.open}
            onClose={handleCloseModalNovoPedido}

            nomeCliente={nomeCliente}
            onChangeNomeCliente={(nome: string) => handleChangeNomeCliente(nome)}

            categorias={categorias}
            categoria={categoriaSelecionada}
            onChangeCategoria={(categoria: string) => handleCategoriaSelecionada(categoria)}

            onChangeEndereco={(endereco: UsuarioEnderecos) => handleChangeEnderecoSelecionado(endereco)}

            itens={itens}

            telefoneCliente={telefoneCliente}
            dadosUsuariosCadastrados={dadosUsuariosCadastrados}
            dadosUsuarioSelecionado={dadosUsuarioSelecionado}
            onChangeUserData={(usuario: Usuario) => handleChangeDadosUsuarioSelecionado(usuario)}
            //onChangeUsuarioSelecionado={(usuario: Usuario) => handleChangeUsuarioSelecionado(usuario)}
            onChangeTelefone={(telefone: string) => handleChangeTelefone(telefone)}

            tipo={tipoPedido}
            onChangeTipoPedido={(tipoPedido: string) => handleChangeTipoPedido(tipoPedido)}

            pedidoPara="AGORA"
            //onChangePedidoPara={(pedido: string) => handleChangePed}

            formasPagamento={formasPagamento}
            formaPagamento={formaSelecionada}
            //formaPagamentoSelecionada={formaSelecionada}
            onChangeFormaPagamento={(formaPagamento: string) => handleChangeFormaPgto(formaPagamento)}

            observacao={observacao}
            onChangeObservacao={(value: string) => handleChangeObservacao(value)}

            carrinho={itensCarrinho}
            onChangeCarrinho={(item: ItemDestaque) => handleChangeCarrinho(item)}
            onChangeQtdItem={(id: string, delta: number) => handleUpdateQtd(id, delta)}
            onChangeRemoveItem={(id: string) => handleRemoveItem(id)}

            vlrTotal={totalGeral}

            onSubmit={() => handleEnvioNovoPedido()}
        />

        {empresa && (
            <ModalDetalhesItemComponent
                open={modalDetalheCatalogo.open}
                onClose={handleCloseModalDetalheCatalogo}
                item={modalDetalheCatalogo.item}
                onClickEscolha={mountItemCarrinho}
                empresa={empresa}
            />
        )}

        <BoxComponent
            component="section"
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 1.5,
                height: "87%",
            }}
        >
            <BoxComponent component="div"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flex: 3,
                    gap: 1,
                    //backgroundColor: 'var(--color-white-solid, #FFFFFF)',
                    borderRadius: '8px',
                    borderTop: '1px solid var(--color-orange-87, #E8DFD5)',
                    boxShadow: '0px 2px 8px 0px rgba(61, 40, 23, 0.08)',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    height: "100%"
                }}
            >
                {pedidosAgrupados?.map((element: PedidosPorStatusDTO, index: number) => {
                    const textoSemCaracteres = removeCaracteresEspeciais(element.status);
                    const cores = pedidoService.getCoresPorStatus(textoSemCaracteres.toUpperCase());

                    return <ListaPedidosComponent
                        key={`lista-pedido-${index}`}
                        categoria={element.status}
                        count={element.quantidade}
                        style={{
                            backgroundMainColor: cores.backgroundColor,
                            backgroundCountColor: cores.borderColor,
                            color: cores.color
                        }}
                        infoPedidos={element.pedidos}
                        onClickPedido={(id: number, element: InfoPedidoProps) => handleClickPedido(id, element)}
                        onClickConfirmacaoPedido={() => null}
                        onClickCancelamentoPedido={() => null}
                    />
                })}
            </BoxComponent>

            <ListaPedidosComponent
                categoria="Detalhes do pedido"
                style={{
                    backgroundMainColor: "#FF7A2A",
                    color: "#FFFFFF"
                }}
                onClickPedido={() => null}
                onClickConfirmacaoPedido={(id: number) => handleClickConfirmacaoPedido(id)}
                infoPedido={detalhePedido}
                onClickCancelamentoPedido={(id: number) => handleCancelaPedido(id)}
            />
        </BoxComponent >
    </>
}

export default PedidosPage;